/* Bundle upgrade cards: the checkbox is a SELECTION only (no instant add).
   When the customer clicks the main Add to Cart button (the product form
   dispatches on:cart:add / on:line-item:change), any ticked packs are added to
   the cart alongside the product, then the cart drawer is refreshed. */
(function () {
  function selectedVariantIds() {
    var ids = [];
    document.querySelectorAll('.bundle-card__checkbox:checked').forEach(function (cb) {
      if (!cb.disabled && cb.dataset.variantId) ids.push(Number(cb.dataset.variantId));
    });
    return ids;
  }

  function addPacks(ids) {
    if (!ids.length) return Promise.resolve(null);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    }).then(function (r) { return r.json(); });
  }

  var busy = false;

  function onMainAdd(e) {
    // Only react to the main product form's add — ignore quick-add drawers.
    var pf = e.target && e.target.closest ? e.target.closest('product-form') : null;
    if (!pf || pf.closest('quick-add-drawer')) return;

    var ids = selectedVariantIds();
    if (!ids.length || busy) return;

    busy = true;
    addPacks(ids)
      .then(function () {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  document.addEventListener('on:cart:add', onMainAdd);
  document.addEventListener('on:line-item:change', onMainAdd);

  /* ---- Sticky bar total = bike price + ticked pack prices ---- */
  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    function fmt(precision, thousands, decimal) {
      var n = (cents / 100).toFixed(precision);
      var p = n.split('.');
      var dollars = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dollars + (p[1] ? decimal + p[1] : '');
    }
    var m = (format || '').match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format || '';
    var val;
    switch (m[1]) {
      case 'amount_no_decimals': val = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': val = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(0, '.', ','); break;
      case 'amount_with_space_separator': val = fmt(2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': val = fmt(0, ' ', '.'); break;
      default: val = fmt(2, ',', '.'); // amount
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function recalcSticky() {
    var cur = document.querySelector('.ampd-sticky-atc__current');
    if (!cur) return;
    var base = parseInt(cur.getAttribute('data-base-price') || '0', 10);
    if (!base) return;
    var packs = 0;
    document.querySelectorAll('.bundle-card__checkbox:checked').forEach(function (cb) {
      packs += parseInt(cb.dataset.price || '0', 10);
    });
    var bar = document.querySelector('ampd-sticky-atc');
    var fmt = (bar && bar.dataset.moneyFormat) || '${{amount}}';
    var str = formatMoney(base + packs, fmt);
    if (cur.textContent.trim() !== str) cur.textContent = str; // guard prevents observer loop
  }

  // Show the selected pack in the sticky bar (desktop only, via CSS). One pack
  // shows its name; two or more collapse to "+ accessories" so it stays short.
  function updateStickyUpgrades() {
    var el = document.querySelector('.ampd-sticky-atc__upgrades');
    if (!el) return;
    var checked = document.querySelectorAll('.bundle-card__checkbox:checked');
    // Always show the name of the first-selected bundle (no "+ accessories").
    var text = !checked.length ? '' : '+ ' + (checked[0].dataset.title || 'accessory');
    var hidden = !checked.length;
    // Only write when something actually changed — writing textContent every
    // time re-triggers the sticky-bar MutationObserver and loops forever.
    if (el.hidden !== hidden) el.hidden = hidden;
    if (el.textContent !== text) el.textContent = text;
  }

  var stickyObserver = null;
  function syncSticky() {
    // Pause the observer while we write into the bar so our own edits don't
    // feed back into another syncSticky (which froze the page).
    if (stickyObserver) stickyObserver.disconnect();
    recalcSticky();
    updateStickyUpgrades();
    if (stickyObserver) reconnectSticky();
  }
  function reconnectSticky() {
    var bar = document.querySelector('ampd-sticky-atc');
    if (bar && stickyObserver) {
      stickyObserver.observe(bar, { childList: true, subtree: true, characterData: true });
    }
  }

  // Recalc when a pack is ticked/unticked.
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.bundle-card__checkbox')) syncSticky();
  });

  /* ---- Variant picker on multi-option packs ----
     Switching the option re-points the checkbox at the chosen variant (so the
     right item is added) and rewrites the visible price, then re-syncs the
     sticky total in case the pack is already ticked. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-bundle-variant]') : null;
    if (!sel) return;
    var card = sel.closest('[data-bundle-card]');
    var opt = sel.options[sel.selectedIndex];
    if (!card || !opt) return;

    var cb = card.querySelector('.bundle-card__checkbox');
    if (cb) {
      cb.dataset.variantId = opt.value;
      cb.dataset.price = opt.dataset.price || '0';
    }

    // Thumbnail follows the variant (colour), falling back to the product image.
    var img = card.querySelector('.bundle-card__img');
    if (img) {
      var src = opt.dataset.img || img.dataset.defaultSrc;
      if (src && img.getAttribute('src') !== src) {
        img.removeAttribute('srcset');
        img.setAttribute('src', src);
      }
    }

    var now = card.querySelector('.bundle-card__now');
    var was = card.querySelector('.bundle-card__was');
    var save = card.querySelector('.bundle-card__save');
    if (now) now.textContent = '+ ' + (opt.dataset.money || '');
    var price = parseInt(opt.dataset.price || '0', 10);
    var compare = parseInt(opt.dataset.compare || '0', 10);
    var hasSave = compare > price;
    if (was) { was.hidden = !hasSave; if (hasSave) was.textContent = opt.dataset.compareMoney || ''; }
    if (save) {
      save.hidden = !hasSave;
      if (hasSave) {
        var bar = document.querySelector('ampd-sticky-atc');
        var fmt = (bar && bar.dataset.moneyFormat) || '${{amount}}';
        save.textContent = 'Save ' + formatMoney(compare - price, fmt).replace(/\.00$/, '');
      }
    }
    syncSticky();
  });
  // The picker sits inside the card's <label>; make sure interacting with it
  // never reads as a click on the card.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-bundle-variant]')) e.stopPropagation();
  }, true);

  // Re-sync when the sticky bar re-renders (variant change) — watch the bar.
  function watchSticky() {
    var bar = document.querySelector('ampd-sticky-atc');
    if (!bar) return;
    stickyObserver = new MutationObserver(function () { syncSticky(); });
    stickyObserver.observe(bar, { childList: true, subtree: true, characterData: true });
    syncSticky();
  }
  if (document.readyState !== 'loading') watchSticky();
  else document.addEventListener('DOMContentLoaded', watchSticky);

  // "Show more" toggle — reveal/hide the collapsed packs.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bundle-more]') : null;
    if (!btn) return;
    var wrap = btn.closest('[data-bundle-collapsible]');
    if (!wrap) return;
    var expanded = wrap.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var txt = btn.querySelector('.bundle-cards__more-text');
    if (txt) txt.textContent = expanded ? (btn.dataset.lessText || 'Show less') : (btn.dataset.moreText || 'Show more');
  });
})();

/* ---- Custom variant dropdown (desktop only) ----------------------------
   The native <select> stays the source of truth: it holds the option data,
   receives the value, and fires the change event the pricing/image/variant
   code above already listens for. This only draws a replacement UI over it,
   because macOS renders a native select's popup itself - it centres the
   selected row over the control and paints its own tick, which sits at odds
   with the rest of the buy box and can't be styled.

   CSS shows this UI from 750px up and keeps the native control below that:
   on a phone the OS picker is genuinely better (thumb-sized, familiar), so
   nothing changes there. Because the swap is done in CSS, resizing the
   window moves between them without any JS. */
(function () {
  var OPEN = 'is-open';

  function buildFor(select) {
    if (select.dataset.bcselBuilt) return;
    select.dataset.bcselBuilt = '1';

    var wrap = document.createElement('div');
    wrap.className = 'bcsel';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bcsel__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', select.getAttribute('aria-label') || 'Choose an option');
    btn.innerHTML = '<span class="bcsel__value"></span>' +
      '<svg class="bcsel__chev" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

    var list = document.createElement('ul');
    list.className = 'bcsel__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    Array.prototype.forEach.call(select.options, function (o, i) {
      var li = document.createElement('li');
      li.className = 'bcsel__opt';
      li.setAttribute('role', 'option');
      li.dataset.index = String(i);
      if (o.disabled) li.setAttribute('aria-disabled', 'true');
      li.innerHTML = '<svg class="bcsel__tick" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
        '<span class="bcsel__opt-text"></span>';
      li.querySelector('.bcsel__opt-text').textContent = o.text;
      list.appendChild(li);
    });

    wrap.appendChild(btn);
    wrap.appendChild(list);
    select.parentNode.insertBefore(wrap, select.nextSibling);
    sync(wrap, select);
  }

  function sync(wrap, select) {
    wrap.querySelector('.bcsel__value').textContent = select.options[select.selectedIndex].text;
    Array.prototype.forEach.call(wrap.querySelectorAll('.bcsel__opt'), function (li) {
      li.setAttribute('aria-selected', Number(li.dataset.index) === select.selectedIndex ? 'true' : 'false');
    });
  }

  function selectOf(wrap) {
    return wrap.parentNode.querySelector('[data-bundle-variant]');
  }

  function close(wrap) {
    wrap.classList.remove(OPEN);
    wrap.querySelector('.bcsel__btn').setAttribute('aria-expanded', 'false');
    wrap.querySelector('.bcsel__list').hidden = true;
  }

  function closeAll(except) {
    document.querySelectorAll('.bcsel.' + OPEN).forEach(function (w) { if (w !== except) close(w); });
  }

  function open(wrap) {
    closeAll(wrap);
    wrap.classList.add(OPEN);
    wrap.querySelector('.bcsel__btn').setAttribute('aria-expanded', 'true');
    wrap.querySelector('.bcsel__list').hidden = false;
    var sel = wrap.querySelector('.bcsel__opt[aria-selected="true"]');
    if (sel) sel.focus ? null : null;
  }

  function choose(wrap, index) {
    var select = selectOf(wrap);
    if (!select || select.options[index].disabled) return;
    select.selectedIndex = index;
    sync(wrap, select);
    // Hand back to the native control so the existing price / image / variant
    // handlers run exactly as they do on mobile.
    select.dispatchEvent(new Event('change', { bubbles: true }));
    close(wrap);
    wrap.querySelector('.bcsel__btn').focus();
  }

  // The dropdown lives inside the card's <label>, so every interaction is
  // stopped from bubbling - otherwise it would toggle the pack's checkbox.
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest ? e.target.closest('.bcsel') : null;
    if (!wrap) { closeAll(null); return; }
    e.preventDefault();
    e.stopPropagation();

    var opt = e.target.closest('.bcsel__opt');
    if (opt) {
      if (opt.getAttribute('aria-disabled') !== 'true') choose(wrap, Number(opt.dataset.index));
      return;
    }
    if (e.target.closest('.bcsel__btn')) {
      wrap.classList.contains(OPEN) ? close(wrap) : open(wrap);
    }
  });
  document.addEventListener('mousedown', function (e) {
    if (e.target.closest && e.target.closest('.bcsel')) e.preventDefault();
  });

  document.addEventListener('keydown', function (e) {
    var wrap = e.target.closest ? e.target.closest('.bcsel') : null;
    if (!wrap) return;
    var isOpen = wrap.classList.contains(OPEN);
    var select = selectOf(wrap);
    if (!select) return;

    if (e.key === 'Escape' && isOpen) { e.stopPropagation(); close(wrap); return; }
    if (!isOpen && (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown')) {
      e.preventDefault(); e.stopPropagation(); open(wrap); return;
    }
    if (isOpen && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault(); e.stopPropagation();
      var step = e.key === 'ArrowDown' ? 1 : -1;
      var i = select.selectedIndex;
      for (var n = 0; n < select.options.length; n++) {
        i += step;
        if (i < 0 || i >= select.options.length) return;
        if (!select.options[i].disabled) { select.selectedIndex = i; sync(wrap, select); return; }
      }
    }
    if (isOpen && e.key === 'Enter') {
      e.preventDefault(); e.stopPropagation();
      choose(wrap, select.selectedIndex);
    }
  });

  function init() {
    document.querySelectorAll('[data-bundle-variant]').forEach(buildFor);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
